import { SelectTypes } from 'components/Select/Select.props'

export const MEMBER_TYPE: SelectTypes[] = [
  { label: 'No membership structure', value: 'no membership structure' },
  { label: 'Nonmembers and members', value: 'nonmembers and members' },
  { label: 'Members only', value: 'members only' },
  { label: 'Custom', value: 'custom' },
]

export const MANUAL_PAYMENT_PROCESSOR: SelectTypes[] = [
  { label: 'Stripe', value: 'stripe' },
  { label: 'Chosen Payments', value: 'chosen_payments' },
]

export const ONLINE_PAYMENT_PROCESSOR: SelectTypes[] = [
  { label: 'Online Stripe', value: 'online_stripe' },
  { label: 'Online Chose Payments', value: 'online_chosen_payments' },
]
